import React from 'react'
import './HowItWorks.css'
import Footer from '../../components/Footer/Footer'

function HowItWorks() {
  return (
    <>
      <div className='container'>
        <div className='jumbotron' id='content'>
          <p></p>
          <p>
            <strong>IPA Integrated Post Analysis</strong>
          </p>

          <p>
            {' '}
            IPA is a service offered as a part of WirelessNeoVi that allows
            Python scripts to be run on both static datasets from the data
            archive, as well as dynamically on data as it is collected, for the
            purpose of analysis. This document serves to break apart the
            components of IPA and explain the intended usage each component as
            well as the service as a whole.{' '}
          </p>

          <p>
            <strong>Analyzers:</strong>
          </p>

          <p>
            Analyzers are the primary component of IPA and consist of many of
            the other components. Analyzers are easy to generate and edit and
            belong to the User who created them specifically. To create one,
            simply navigate to IPA &gt; Analyzer in the nav bar, and click the
            “Generate” button which will prompt you to provide the components of
            an Analyzer.{' '}
          </p>

          <p>
            Analyzer’s necessarily require a Name, a Run Type ( either Dynamic
            or Static ), an Analysis Script, and a Dataset. An Analyzer also
            optionally includes Configurations, and Users with whom you’d wish
            to automatically share the results of the analysis with upon
            completion. Multiple Analysis Scripts, Datasets, Configurations, and
            Users may be applied to a given Analyzer.
          </p>

          <p>
            When an Analyzer has been created you will see it on the grid on the
            Analyzer page. To run a static Analyzer simply click the run icon on
            the left of the grid. This will create a new Run in the RunQueue
            with a status of New, which will get picked up by the IPA Scanner
            and processed. Processing in this case means a container will be
            launched with all the necessary information, then the selected
            Analysis script will run with any optional configurations on the
            selected data set(s), and the results will be outputted to the
            Results page. If there were any issues with the container or the
            Python script during processing, you will see a DockerLog.txt file
            appear in the results which contains the error message.{' '}
          </p>

          <p>
            {' '}
            To activate a Dynamic dataset you simply click the “active” check
            mark on the grid. The check mark box will be green when it is
            active. When a dynamic Dataset is active it means all new uploaded
            collections will be checked against the dataset criteria, and if
            they match, the analysis will be run.{' '}
          </p>

          <p>
            {' '}
            You can edit or delete Analyzers, using the corresponding grid
            buttons, as you see fit as all Analyzers are unique to the person
            who created them.{' '}
          </p>

          <p>
            <strong>Results:</strong>
          </p>

          <p>
            {' '}
            The results page is mostly equivalent to the data archive page,
            except instead of storing collections to search through, analysis
            reports are stored.{' '}
          </p>

          <p>
            {' '}
            Clicking Search without any parameters specified will display all
            user and shared results. You can specify one or the other by using
            the associated radio buttons.{' '}
          </p>

          <p>
            {' '}
            A result file that is shared will be displayed as a link. Clicking
            on it will show the user who shared the file with you. Files can be
            shared either manually on the Results page by selecting files and
            clicking on the "[x] Files Selected” dropdown and selecting Share
            Selections, or automatically by specifying users to share with in
            the Analyzer.{' '}
          </p>

          <p>
            {' '}
            Files can also be deleted or downloaded through the “Files Selected”
            dropdown.{' '}
          </p>

          <p>
            {' '}
            Select file types can also be “quick viewed” in the browser, or if
            appropriate, viewed externally in Dataspy.{' '}
          </p>

          <p>
            <strong>Run Queue:</strong>
          </p>

          <p>
            {' '}
            The Run Queue is used for observing and managing existing and
            previous “Runs”, AKA a time when an Analyzer has tried to apply an
            Analysis Script(s) to Dataset(s).{' '}
          </p>

          <p>
            {' '}
            Runs can be deleted from the queue by selecting the check mark
            associated with the row and then selecting Actions &gt; Delete
            Selected. These runs will not be deleted if the status is not “NEW”
            or “STARTED”, you must cancel them first.{' '}
          </p>

          <p>
            {' '}
            Runs can be cancelled by selecting the check mark associated with
            the row and then selecting Actions &gt; Cancel Selected. This will
            kill the container that is being run and end the analysis where it
            was taking place. Cancelling will only work if the Run has a status
            of “NEW” or “STARTED”.{' '}
          </p>

          <p>
            <strong>Scripts:</strong>
          </p>

          <p>
            {' '}
            Analysis Scripts are used by Analyzer to process data. Scripts can
            be used by any User in their organization.{' '}
          </p>

          <p>
            {' '}
            An Analysis Script may be uploaded by all users but it must be
            approved by an administrator before it can be assigned to an
            Analyzer.{' '}
          </p>

          <p>
            {' '}
            Before granting approval the administrator should perform, at
            minimum, a cursory inspection to check for potential improper
            behavior.{' '}
          </p>

          <p>
            {' '}
            After uploading a script an administrator will be notified to review
            it, once reviewed, the uploader will receive a notification that it
            has been accepted or rejected.{' '}
          </p>

          <p>
            {' '}
            If the script has been rejected, you may edit it and resubmit.{' '}
          </p>

          <p>
            {' '}
            A script can only be used by an Analyzer after it has been accepted.{' '}
          </p>

          <p>
            <strong>Configurations:</strong>
          </p>

          <p>
            {' '}
            Configurations are optional for Analyzers but can be used to
            configure the operation of an Analysis Script based on parameters
            contained within.{' '}
          </p>

          <p>
            {' '}
            It could be as simple as passing a parameter to make a different
            method in the script run or as complex as to dictate what to search
            for in the data.{' '}
          </p>

          <p>
            <strong>Datasets:</strong>
          </p>

          <p>
            {' '}
            There are two types of datasets, static and dynamic, that can be
            used with IPA.{' '}
          </p>

          <p>
            {' '}
            A Static Dataset consists of the specific files the dataset creator
            has chosen or via specific criteria. These datasets can be created
            in the data archive by selecting the files and choosing “Create Data
            Set”; they can also be created via the generate page. To do so,
            select the expected criteria, and make sure the selected type is
            “Static”.{' '}
          </p>

          <p>
            {' '}
            Analyzing the files in a Static Dataset is a one time process done
            by simply selecting the Dataset for an Analyzer and clicking the
            “Run” icon on the Analyzers page.{' '}
          </p>

          <p>
            {' '}
            A Dynamic Dataset consists of search criteria to match files
            against, instead of specific files. For example, when creating a
            Dynamic Dataset you could simply specify a vehicle, and the dataset
            would entail every collection associated with that vehicle, as
            opposed to going and selecting all the files associated with that
            vehicle yourself. Dynamic Data Sets at the moment can only match
            against future uploads.The analysis will be run on incoming
            collections as long as the Dataset is active. Activating the in a
            Dynamic Dataset is done by simply selecting the Dataset for an
            Analyzer and clicking the “Active” icon on the Analyzers.{' '}
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default HowItWorks
